import { StrictLocalizeFunction } from "@faire/web/common/localization";

interface IAction {
  title: string;
  description: string;
  number?: string;
}

const CULTURAL = (strictLocalize: StrictLocalizeFunction): IAction => ({
  title: strictLocalize({
    defaultMessage: "Cultural programming",
    description: {
      text: "Title of an action in the list of actions that Faire has done",
    },
  }),
  description: strictLocalize({
    defaultMessage:
      "We celebrate cultural moments throughout the year with programming centered " +
      "on education, celebration, and introspection to help further connect our employees.",
    description: {
      text: "description of an action in the list of actions that Faire has done",
    },
  }),
  number: "01",
});

const TRANSPARENCY = (strictLocalize: StrictLocalizeFunction): IAction => ({
  title: strictLocalize({
    defaultMessage: "Transparency for all",
    description: {
      text: "Title of an action in the list of actions that Faire has done",
    },
  }),
  description: strictLocalize({
    defaultMessage:
      "We want all our employees to feel seen and heard. We frequently report findings " +
      "from our engagement surveys and focus group listening sessions to hold ourselves " +
      "accountable for improving our employee experience.",
    description: {
      text: "description of an action in the list of actions that Faire has done",
    },
  }),
  number: "02",
});

const HIRING = (strictLocalize: StrictLocalizeFunction): IAction => ({
  title: strictLocalize({
    defaultMessage: "Hiring & retention processes",
    description: {
      text: "Title of an action in the list of actions that Faire has done",
    },
  }),
  description: strictLocalize({
    defaultMessage:
      "We collect aggregate voluntary demographic data and conduct regular audits of our " +
      "global talent practices to ensure our processes are fair and equitable.",
    description: {
      text: "description of an action in the list of actions that Faire has done",
    },
  }),
  number: "03",
});

const EMPLOYEE = (strictLocalize: StrictLocalizeFunction): IAction => ({
  title: strictLocalize({
    defaultMessage: "Employee development",
    description: {
      text: "Title of an action in the list of actions that Faire has done",
    },
  }),
  description: strictLocalize({
    defaultMessage:
      "We ensure all employees have equitable opportunities for personal and professional " +
      "growth by providing tools, resources, and workshops on topics like microaggressions, " +
      "pay equity, and imposter syndrome. We also train all of our leaders to support and grow inclusive teams.",
    description: {
      text: "description of an action in the list of actions that Faire has done",
    },
  }),
  number: "04",
});

export const FAIRE_ACTIONS = (
  strictLocalize: StrictLocalizeFunction
): IAction[] => [
  CULTURAL(strictLocalize),
  TRANSPARENCY(strictLocalize),
  HIRING(strictLocalize),
  EMPLOYEE(strictLocalize),
];
